const videos = Object.freeze([
	{
		sermonName: "The Prayer that Avails Much",
		ministryName: "Jeremiah Oei Ministries",
		sermonDate: "2021-09-20",
		pluginAppearsTime: "00:00:41",
		pluginTheme: "Heavenly: Golden Brown",
		countryCode2: "ID",
		video: {
			type: "YOUTUBE",
			id: "R6hK6qqmmew",
		},
	},

	{
		sermonName: "Kebanggaan Rasul Paulus",
		ministryName: "Jeremiah Oei Ministries",
		sermonDate: "2022-04-04",
		pluginAppearsTime: "00:03:07",
		pluginTheme: "Cross and Thorns: 1",
		countryCode2: "ID",
		video: {
			type: "YOUTUBE",
			id: "dxhP4a6pi90",
		},
	},

	{
		sermonName: "Examinando nuestra relación con Cristo",
		ministryName: "Tabernáculo Bíblico Bautista",
		sermonDate: "2022-04-03",
		pluginAppearsTime: "00:07:15",
		pluginTheme: "Default: Dark (Modified)",
		countryCode2: "UY",
		video: {
			type: "YOUTUBE",
			id: "4j2xxjI8pPY",
		},
	},

	{
		sermonName: "-SERVICIO DÍA MIÉRCOLES-",
		ministryName: "Iglesia Ministerios Internacional Kairos Mazatenango",
		sermonDate: "2022-04-14",
		pluginAppearsTime: "00:48:30",
		pluginTheme: "Nature: Ocean",
		countryCode2: "GT",
		video: {
			type: "FACEBOOK",
			link: "https://fb.watch/cnmjv7DWzk/",
			thumbnail: "iglesia-ministerios-internacional-kairos-mazatenango.png",
		},
	},

	{
		sermonName: "Palm Sunday 4/10/22",
		ministryName: "First Presbyterian Church of Harborcreek",
		sermonDate: "2022-04-10",
		pluginAppearsTime: "00:43:52",
		pluginTheme: "Default: Dark",
		countryCode2: "US",
		video: {
			type: "FACEBOOK",
			link: "https://fb.watch/cC1HAsEd_v/",
			thumbnail: "first-presbyterian-church-of-harborcreek.png",
		},
	},

	{
		sermonName: "Bautizados en el Espíritu Santo y fuego - Pra Cecilia Bogdan",
		ministryName: "Somos Llave",
		sermonDate: "2022-04-10",
		pluginAppearsTime: "00:41:06",
		pluginTheme: "Echoes: Red",
		countryCode2: "AR",
		video: {
			type: "YOUTUBE",
			id: "SOLAwa-4xpc",
		},
	},

	{
		sermonName: "Los Actos de YAHWEH Para Salvar",
		ministryName: "La Casa De Oracion Christian Church, Weslaco Tx",
		sermonDate: "2022-04-13",
		pluginAppearsTime: "00:33:47",
		pluginTheme: "Cross and Thorns: 5",
		countryCode2: "US",
		video: {
			type: "FACEBOOK",
			link: "https://www.facebook.com/lacasadeoracion/videos/378772177298873",
			thumbnail: "la-casa-de-oracion.png",
		},
	},

	{
		sermonName: "TRAFFIC JAM FELLOWSHIP",
		ministryName: "Dar es salaam International Church",
		sermonDate: "2022-02-08",
		pluginAppearsTime: "00:03:19",
		pluginTheme: "Heavenly: Lavender",
		countryCode2: "TZ",
		video: {
			type: "FACEBOOK",
			link: "https://fb.watch/cC2QHFNtcm/",
			thumbnail: "dar-es-salaam-international-church.png",
		},
	},

	{
		sermonName: "Livestream Service | April 10, 2022 - Palm Sunday",
		ministryName: "O'Brien Church of God",
		sermonDate: "2022-04-10",
		pluginAppearsTime: "00:16:00",
		pluginTheme: "Bookmark: Green",
		countryCode2: "CA",
		video: {
			type: "YOUTUBE",
			id: "TDE2TgCuFIE"
		},
	},

	{
		sermonName: "San Juan SDA Sabbath Worship (April 9th)",
		ministryName: "San Juan S.D.A",
		sermonDate: "2022-04-09",
		pluginAppearsTime: "01:18:20",
		pluginTheme: "Default: Dark",
		countryCode2: "TT",
		video: {
			type: "YOUTUBE",
			id: "bFPk07cvr3c",
		},
	},

	{
		sermonName: "Noche de Adoración y Lectura de la Biblia 13-04-2022",
		ministryName: "Christopher Barboza",
		sermonDate: "2022-04-13",
		pluginAppearsTime: "00:37:30",
		pluginTheme: "Heavenly: Black",
		countryCode2: "NI",
		video: {
			type: "FACEBOOK",
			link: "https://fb.watch/cC3zRgrUmA/",
			thumbnail: "christopher-barboza.png",
		},
	},

	{
		sermonName: "POWEr || Theme: “The Storm Within” || with Eld. Bradley Jackson || 2 Apr 2022",
		ministryName: "Paradise Media Ministries",
		sermonDate: "2022-04-02",
		pluginAppearsTime: "01:58:50",
		pluginTheme: "Echoes: Blue",
		countryCode2: "VC",
		video: {
			type: "YOUTUBE",
			id: "Lvjhb7eX_0g",
		},
	},

	{
		sermonName: "En vivo desde Iglesia Misión Emanuel",
		ministryName: "Misión Emanuel",
		sermonDate: "2022-04-10",
		pluginAppearsTime: "00:49:43",
		pluginTheme: "Echoes: Purple",
		countryCode2: "CR",
		video: {
			type: "YOUTUBE",
			id: "d1DFikPR1bM",
		},
	},

	{
		sermonName: "Lord, what Wilt Thou Have Me To Do? Part 2 | Sunday 20-03-2022",
		ministryName: "Destiny Church International Breda",
		sermonDate: "2022-03-20",
		pluginAppearsTime: "00:54:03",
		pluginTheme: "Echoes: Blue",
		countryCode2: "NL",
		video: {
			type: "YOUTUBE",
			id: "fvzpLIR9bAE",
		},
	},

	{
		sermonName: "La Iglesia En Casa A Los Pies del Maestro",
		ministryName: "Iglesia Cristiana Jehová Shammah",
		sermonDate: "2022-03-12",
		pluginAppearsTime: "00:20:20",
		pluginTheme: "Heavenly: Golden Brown",
		countryCode2: "PE",
		video: {
			type: "FACEBOOK",
			link: "https://fb.watch/cC4oi8V8yn/",
			thumbnail: "iglesia-cristiana-jehova-shammah.jpg",
		},
	},

	{
		sermonName: "The Veil Removed | Pastor Anthony Pillay | Good Tidings FGC",
		ministryName: "Good Tidings Full Gospel Church",
		sermonDate: "2022-04-15",
		pluginAppearsTime: "00:34:30",
		pluginTheme: "Echoes: Red (modified)",
		countryCode2: "ZA",
		video: {
			type: "YOUTUBE",
			id: "rhprfg3Ow5w",
		},
	},

	{
		sermonName: "Faith in the Word Sunday Service - Resurrection Sunday",
		ministryName: "Faith in the Word",
		sermonDate: "2022-04-17",
		pluginAppearsTime: "01:02:50",
		pluginTheme: "Echoes: Peach",
		countryCode2: "US",
		video: {
			type: "FACEBOOK",
			link: "https://fb.watch/crXMpdK3ZY/",
			thumbnail: "faith-in-the-word.png",
		},
	},

	{
		sermonName: "Las funciones de la boca | Francisco Jaramillo",
		ministryName: "Centro Evangelistico Maranatha",
		sermonDate: "2022-04-18",
		pluginAppearsTime: "00:13:34",
		pluginTheme: "Nature: Ocean",
		countryCode2: "CO",
		video: {
			type: "YOUTUBE",
			id: "R4A-rMxDtVU",
		},
	},

	{
		sermonName: "Today's BREAKTHROUGH",
		ministryName: "Breakthrough Christian Fellowship",
		sermonDate: "2024-01-08",
		pluginAppearsTime: "00:07:31",
		pluginTheme: "Script: Blue",
		countryCode2: "PH",
		video: {
			type: "FACEBOOK",
			link: "https://fb.watch/pv2aOqizB9/",
			thumbnail: "todays-breakthrough.png",
		},
	},
]);

const countryData = Object.freeze([
	{
		code2: "AG",
		code3: "ATG",
		name: "Antigua and Barbuda",
	},

	{
		code2: "AR",
		code3: "ARG",
		name: "Argentina",
	},

	{
		code2: "AW",
		code3: "ABW",
		name: "Aruba",
	},

	{
		code2: "AU",
		code3: "AUS",
		name: "Australia",
	},

	{
		code2: "AT",
		code3: "AUT",
		name: "Austria",
	},

	{
		code2: "BS",
		code3: "BHS",
		name: "Bahamas",
	},

	{
		code2: "BB",
		code3: "BRB",
		name: "Barbados",
	},

	{
		code2: "BZ",
		code3: "BLZ",
		name: "Belize",
	},

	{
		code2: "BE",
		code3: "BEL",
		name: "Belgium",
	},

	{
		code2: "BJ",
		code3: "BEN",
		name: "Benin",
	},

	{
		code2: "BO",
		code3: "BOL",
		name: "Bolivia",
	},

	{
		code2: "BW",
		code3: "BWA",
		name: "Botswana",
	},

	{
		code2: "BR",
		code3: "BRA",
		name: "Brazil",
	},

	{
		code2: "BG",
		code3: "BGR",
		name: "Bulgaria",
	},

	{
		code2: "CM",
		code3: "CMR",
		name: "Cameroon",
	},

	{
		code2: "CA",
		code3: "CAN",
		name: "Canada",
	},

	{
		code2: "CL",
		code3: "CHL",
		name: "Chile",
	},

	{
		code2: "CO",
		code3: "COL",
		name: "Colombia",
	},

	{
		code2: "CG",
		code3: "COG",
		name: "Congo Republic",
	},

	{
		code2: "CR",
		code3: "CRI",
		name: "Costa Rica",
	},

	{
		code2: "CW",
		code3: "CUW",
		name: "Curaçao",
	},

	{
		code2: "CD",
		code3: "COD",
		name: "Democratic Republic of the Congo",
	},

	{
		code2: "DO",
		code3: "DOM",
		name: "Dominican Republic",
	},

	{
		code2: "EC",
		code3: "ECU",
		name: "Ecuador",
	},

	{
		code2: "SV",
		code3: "SLV",
		name: "El Salvador",
	},

	{
		code2: "FM",
		code3: "FSM",
		name: "Federated States of Micronesia",
	},

	{
		code2: "FJ",
		code3: "FJI",
		name: "Fiji",
	},

	{
		code2: "FI",
		code3: "FIN",
		name: "Finland",
	},

	{
		code2: "FR",
		code3: "FRA",
		name: "France",
	},

	{
		code2: "GF",
		code3: "GUF",
		name: "French Guiana",
	},

	{
		code2: "GA",
		code3: "GAB",
		name: "Gabon",
	},

	{
		code2: "GM",
		code3: "GMB",
		name: "Gambia",
	},

	{
		code2: "DE",
		code3: "DEU",
		name: "Germany",
	},

	{
		code2: "GH",
		code3: "GHA",
		name: "Ghana",
	},

	{
		code2: "GT",
		code3: "GTM",
		name: "Guatemala",
	},

	{
		code2: "HN",
		code3: "HND",
		name: "Honduras",
	},

	{
		code2: "HK",
		code3: "HKG",
		name: "Hong Kong",
	},

	{
		code2: "IN",
		code3: "IND",
		name: "India",
	},

	{
		code2: "ID",
		code3: "IDN",
		name: "Indonesia",
	},

	{
		code2: "IE",
		code3: "IRL",
		name: "Ireland",
	},

	{
		code2: "IM",
		code3: "IMN",
		name: "Isle of Man",
	},

	{
		code2: "IL",
		code3: "ISR",
		name: "Israel",
	},

	{
		code2: "IT",
		code3: "ITA",
		name: "Italy",
	},

	{
		code2: "CI",
		code3: "CIV",
		name: "Ivory Coast",
	},

	{
		code2: "JM",
		code3: "JAM",
		name: "Jamaica",
	},

	{
		code2: "JP",
		code3: "JPN",
		name: "Japan",
	},

	{
		code2: "KE",
		code3: "KEN",
		name: "Kenya",
	},

	{
		code2: "LV",
		code3: "LVA",
		name: "Latvia",
	},

	{
		code2: "LB",
		code3: "LBN",
		name: "Lebanon",
	},

	{
		code2: "LU",
		code3: "LUX",
		name: "Luxembourg",
	},

	{
		code2: "MW",
		code3: "MWI",
		name: "Malawi",
	},

	{
		code2: "MY",
		code3: "MYS",
		name: "Malaysia",
	},

	{
		code2: "MQ",
		code3: "MTQ",
		name: "Martinique",
	},

	{
		code2: "MU",
		code3: "MUS",
		name: "Mauritius",
	},

	{
		code2: "MX",
		code3: "MEX",
		name: "Mexico",
	},

	{
		code2: "NA",
		code3: "NAM",
		name: "Namibia",
	},

	{
		code2: "NL",
		code3: "NLD",
		name: "Netherlands",
	},

	{
		code2: "NZ",
		code3: "NZL",
		name: "New Zealand",
	},

	{
		code2: "NI",
		code3: "NIC",
		name: "Nicaragua",
	},

	{
		code2: "NG",
		code3: "NGA",
		name: "Nigeria",
	},

	{
		code2: "PA",
		code3: "PAN",
		name: "Panama",
	},

	{
		code2: "PE",
		code3: "PER",
		name: "Peru",
	},

	{
		code2: "PH",
		code3: "PHL",
		name: "Philippines",
	},

	{
		code2: "PT",
		code3: "PRT",
		name: "Portugal",
	},

	{
		code2: "PR",
		code3: "PRI",
		name: "Puerto Rico",
	},

	{
		code2: "RO",
		code3: "ROU",
		name: "Romania",
	},

	{
		code2: "RU",
		code3: "RUS",
		name: "Russia",
	},

	{
		code2: "SN",
		code3: "SEN",
		name: "Senegal",
	},

	{
		code2: "SC",
		code3: "SYC",
		name: "Seychelles",
	},

	{
		code2: "SL",
		code3: "SLE",
		name: "Sierra Leone",
	},

	{
		code2: "SG",
		code3: "SGP",
		name: "Singapore",
	},

	{
		code2: "SX",
		code3: "SXM",
		name: "Sint Maarten",
	},

	{
		code2: "SK",
		code3: "SVK",
		name: "Slovakia",
	},

	{
		code2: "ZA",
		code3: "ZAF",
		name: "South Africa",
	},

	{
		code2: "KR",
		code3: "KOR",
		name: "South Korea",
	},

	{
		code2: "LK",
		code3: "LKA",
		name: "Sri Lanka",
	},

	{
		code2: "VC",
		code3: "VCT",
		name: "St Vincent & the Grenadines",
	},

	{
		code2: "ES",
		code3: "ESP",
		name: "Spain",
	},

	{
		code2: "SE",
		code3: "SWE",
		name: "Sweden",
	},

	{
		code2: "CH",
		code3: "CHE",
		name: "Switzerland",
	},

	{
		code2: "TZ",
		code3: "TZA",
		name: "Tanzania",
	},

	{
		code2: "TH",
		code3: "THA",
		name: "Thailand",
	},

	{
		code2: "TG",
		code3: "TGO",
		name: "Togo",
	},

	{
		code2: "TT",
		code3: "TTO",
		name: "Trinidad and Tobago",
	},

	{
		code2: "UG",
		code3: "UGA",
		name: "Uganda",
	},

	{
		code2: "UA",
		code3: "UKR",
		name: "Ukraine",
	},

	{
		code2: "AE",
		code3: "ARE",
		name: "United Arab Emirates",
	},

	{
		code2: "GB",
		code3: "GBR",
		name: "United Kingdom",
	},

	{
		code2: "US",
		code3: "USA",
		name: "United States",
	},

	{
		code2: "UY",
		code3: "URY",
		name: "Uruguay",
	},

	{
		code2: "VE",
		code3: "VEN",
		name: "Venezuela",
	},

	{
		code2: "VN",
		code3: "VNM",
		name: "Vietnam",
	},

	{
		code2: "ZM",
		code3: "ZMB",
		name: "Zambia",
	},

	{
		code2: "ZW",
		code3: "ZWE",
		name: "Zimbabwe",
	},
]);

const videoCountryCodes2 = new Set(
	videos.map(v => v.countryCode2)
);

let map;

/**
 * Syncs the country selector, country flag icon, map, and video list with the
 * selected country.
 */
const updateCountry = (selectedCountry) => {
	const countrySelector = document.getElementById("country-select");
	const countryFlagIcon = document.querySelector(".country .flag-icon");
	const videoListEl = document.querySelector(".video-list");

	countryFlagIcon.classList.remove(...countryFlagIcon.classList);
	countryFlagIcon.classList.add("flag-icon", "flag-icon-" + selectedCountry.code2.toLowerCase());
	countryFlagIcon.title = selectedCountry.name;

	countrySelector.value = selectedCountry.code3;

	const mapData = Object.fromEntries(
		countryData.map(country => {
			if (country.code3 === selectedCountry.code3) {
				return [
					country.code3, { fillKey: "highlight" },
				];
			}
			else if (videoCountryCodes2.has(country.code2)) {
				return [
					country.code3, { fillKey: "hasVideo" },
				];
			}
			else {
				return [
					country.code3, { fillKey: "using" },
				];
			}
		}),
	);

	map.updateChoropleth(mapData, { reset: true });

	videoListEl.innerHTML = "";

	const filteredVideos = videos
		.filter(v => v.countryCode2 === selectedCountry.code2);

	filteredVideos
		.forEach(v => {
			const el = renderVideoListItem(v);
			videoListEl.appendChild(el);
		});
}

(() => {
	const countries = countryData.map(c => c.code3);

	map = new Datamap({
    element: document.querySelector(".map"),
    responsive: true,
    fills: {
      defaultFill: "rgb(122, 121, 122)",
      using: "rgb(42, 130, 218)",
      highlight: "rgb(58, 57, 58)",
      hasVideo: "#01594f",
    },
    data: Object.fromEntries(
      countries.map((country) => {
        return [country, { fillKey: "using" }];
      })
    ),
    done: (datamap) => {
      datamap.svg.selectAll(".datamaps-subunit").on("click", (geography) => {
        const selectedCountry = countryData.find(
          (c) => c.code3 === geography.id
        );
        if (!selectedCountry) {
          return;
        }
        if (!videoCountryCodes2.has(selectedCountry.code2)) {
          return;
        }

        updateCountry(selectedCountry);
      });
    },
  });

	window.addEventListener("resize", () => {
		map.resize();
	});
})();

(() => {
	const sortedCountries = [...countryData].sort((a, b) => a.name.localeCompare(b.name));
	let currentCountry = sortedCountries.find(c => c.code3 === "IDN");

	const countrySelector = document.getElementById("country-select");

	sortedCountries
		.forEach(country => {
			const option = document.createElement("option");
			option.value = country.code3;
			option.innerText = country.name;

			if (videos.findIndex(video => video.countryCode2 === country.code2) >= 0) {
				countrySelector.appendChild(option);
			}
		});


	countrySelector.addEventListener("change", () => {
		const selectedCountryCode3 = countrySelector.value;
		currentCountry = sortedCountries.find(c => c.code3 === selectedCountryCode3);
		updateCountry(currentCountry);
	});

	updateCountry(currentCountry);
})();

/** @param {typeof videos[0]} data */
function renderVideoListItem(data) {
	const itemEl = document.createElement("div");
	itemEl.classList.add("item");

	const dataEl = document.createElement("div");
	dataEl.classList.add("data");
	itemEl.appendChild(dataEl);

	const sermonNameEl = document.createElement("span");
	sermonNameEl.classList.add("sermon-name");
	sermonNameEl.innerText = data.sermonName;
	dataEl.appendChild(sermonNameEl);

	const ministryNameEl = document.createElement("span");
	ministryNameEl.classList.add("ministry-name");
	ministryNameEl.innerText = data.ministryName;
	dataEl.appendChild(ministryNameEl);

	const sermonDateEl = document.createElement("span");
	sermonDateEl.classList.add("sermon-date");
	const faCalendarIcon = document.createElement("i");
	faCalendarIcon.classList.add("fas", "fa-fw", "fa-calendar-day");
	faCalendarIcon.title = "Date";
	sermonDateEl.appendChild(faCalendarIcon);
	const sermonDateSpan = document.createElement("span");
	sermonDateSpan.innerText = data.sermonDate;
	sermonDateEl.appendChild(sermonDateSpan);
	dataEl.appendChild(sermonDateEl);

	const sermonTimeEl = document.createElement("span");
	sermonTimeEl.classList.add("sermon-time");
	const faBibleIcon = document.createElement("i");
	faBibleIcon.classList.add("fas", "fa-fw", "fa-bible");
	faBibleIcon.title = "When the Bible plugin appears";
	sermonTimeEl.appendChild(faBibleIcon);
	const sermonTimeSpan = document.createElement("span");
	sermonTimeSpan.innerText = data.pluginAppearsTime;
	sermonTimeEl.appendChild(sermonTimeSpan);
	dataEl.appendChild(sermonTimeEl);

	const sermonThemeEl = document.createElement("span");
	sermonThemeEl.classList.add("sermon-theme");
	const faPaletteIcon = document.createElement("i");
	faPaletteIcon.classList.add("fas", "fa-fw", "fa-palette");
	faPaletteIcon.title = "Theme";
	sermonThemeEl.appendChild(faPaletteIcon);
	const sermonThemeSpan = document.createElement("span");
	sermonThemeSpan.innerText = data.pluginTheme;
	sermonThemeEl.appendChild(sermonThemeSpan);
	dataEl.appendChild(sermonThemeEl);

	const videoWrapperEl = document.createElement("div");
	videoWrapperEl.classList.add("video");
	itemEl.appendChild(videoWrapperEl);

	switch (data.video.type) {
		case "YOUTUBE": {
			const iframeEl = document.createElement("iframe");
			iframeEl.src = "https://www.youtube.com/embed/" + data.video.id;
			videoWrapperEl.appendChild(iframeEl);
			break;
		}

		case "FACEBOOK": {
			const linkEl = document.createElement("a");
			linkEl.href = data.video.link;
			linkEl.target = "_blank";
			linkEl.rel = "noopener";
			linkEl.setAttribute("alt", data.sermonName);
			videoWrapperEl.appendChild(linkEl);

			const imgEl = document.createElement("img");
			imgEl.src = "/thumbnails/" + data.video.thumbnail;
			imgEl.alt = data.sermonName;
			linkEl.appendChild(imgEl);

			const faLinkIcon = document.createElement("i");
			faLinkIcon.classList.add("fas", "fa-external-link-alt");
			linkEl.appendChild(faLinkIcon);
			break;
		}
	}

	return itemEl;
}
